import { defineAsyncComponent, h, createApp } from "vue";
import { mountReplace } from "../../../utilities/mount-replace";

export function mountComponent_footer(selector: string | HTMLElement) {
    const footerComp = defineAsyncComponent(
        () =>
            import(
                /* webpackFetchPriority: "low" */
                "./footer-comp.vue"
            )
    );
    mountReplace(
        createApp({
            name: "footer-component",
            render: function () {
                return h(footerComp);
            },
        }),
        selector
    );
}
